import React from "react";
import { EmployeesPage } from "./EmployeesPage";
import { useEmployees } from "./useEmployees";

function Employees() {
  return <EmployeesPage {...useEmployees()} />;
}

export default Employees;
